import { ref } from 'vue'

export function useLayout() {
  const isDesktop = ref(true)
  function onResize() {
    isDesktop.value = window.innerWidth >= 1024
  }
  window.addEventListener('resize', onResize)
  onResize()

  return {
    isDesktop
  }
}
